import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { Identifier } from '../models/storage.model';
import { getAccessToken } from '../utils/auth.utils';

@Injectable({
  providedIn: 'root',
})
export class RedirectionGuardService implements CanActivate {
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const token = getAccessToken();
    if (!token || this.jwtHelper.isTokenExpired(token)) {
      return true;
    }
    const visibleMenusStorage = localStorage.getItem(Identifier.TYPE_VISIBLE_MENUS);
    const visibleMenus = visibleMenusStorage ? JSON.parse(visibleMenusStorage) : [];
    const pageUrl = visibleMenus?.length && visibleMenus?.includes(1000) ? '/dashboard' : '/manage';
    return this.router.parseUrl(pageUrl);
  }
}
